// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"699561f7","215":"699561f7","550":"699561f7"}[chunkId] + ".chunk.css";
};